// extracted by mini-css-extract-plugin
module.exports = {"layout":"PasswordChange_layout__2wQYF","body":"PasswordChange_body__3eRMg","fieldset":"PasswordChange_fieldset__3NlB7"};